import { render, staticRenderFns } from "./UstBasliklar.vue?vue&type=template&id=a307012a"
import script from "./UstBasliklar.vue?vue&type=script&lang=js"
export * from "./UstBasliklar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports